import { ExternalLink, FileText, Mail, Sparkles } from 'lucide-react';
import { CONTRIBUTOR_ONBOARD_EMAIL, CONTRIBUTOR_TERMS_URL } from '../../lib/env';

const MAILTO_SUBJECT = 'Contributor onboarding inquiry';
const MAILTO_BODY =
  'Hi Coordal team,\n\nI am interested in becoming a paid map contributor. I have read the terms and contract.\n\n';

const HEADLINE = 'Improve Ghana\'s map and get paid for verified contributions';
const BODY =
  'Add places, enrich data, and improve boundaries. Read the terms and contract, then email us to onboard.';

export function ContributorInviteSection() {
  const mailtoHref = `mailto:${CONTRIBUTOR_ONBOARD_EMAIL}?subject=${encodeURIComponent(MAILTO_SUBJECT)}&body=${encodeURIComponent(MAILTO_BODY)}`;
  const termsConfigured = Boolean(CONTRIBUTOR_TERMS_URL);

  return (
    <div className="mx-4 mb-4 rounded-2xl border border-amber-200/80 dark:border-amber-500/25 bg-gradient-to-br from-amber-50 to-orange-50/80 dark:from-amber-950/30 dark:to-orange-950/20 p-4 shadow-sm">
      <div className="flex items-start gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-amber-500/15 text-amber-600 dark:text-amber-400">
          <Sparkles size={18} />
        </div>
        <div className="min-w-0 flex-1">
          <p className="text-[10px] font-semibold uppercase tracking-[0.18em] text-amber-600 dark:text-amber-400">
            Paid contributors
          </p>
          <h4 className="mt-1 text-sm font-semibold text-gray-900 dark:text-white">
            {HEADLINE}
          </h4>
          <p className="mt-1 text-xs leading-relaxed text-gray-600 dark:text-gray-400">
            {BODY}
          </p>

          <div className="mt-3 space-y-2">
            {termsConfigured ? (
              <a
                href={CONTRIBUTOR_TERMS_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 rounded-xl border border-amber-200/80 dark:border-amber-500/20 bg-white/70 dark:bg-gray-900/40 px-3 py-2 text-xs font-medium text-gray-800 dark:text-gray-200 transition-colors hover:border-amber-400/50"
              >
                <FileText size={14} className="shrink-0 text-amber-600 dark:text-amber-400" />
                <span className="flex-1">Terms &amp; contract (PDF)</span>
                <ExternalLink size={12} className="shrink-0 text-gray-400" />
              </a>
            ) : null}

            <a
              href={mailtoHref}
              className="flex items-center justify-center gap-2 rounded-xl bg-amber-500 px-3 py-2 text-xs font-semibold text-white transition-colors hover:bg-amber-600"
            >
              <Mail size={14} />
              Email {CONTRIBUTOR_ONBOARD_EMAIL}
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
